import React, { useState } from "react";
import PropTypes from "prop-types";
import StarRatings from "react-star-ratings";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";
import classes from "./BookALessonWithGalleryMobile.module.css";
import {
  coachDemoImg,
  DisableHeartIcon,
  DummyVideo,
  GalleryImg1,
  GalleryImg2,
  GalleryImg3,
  messageIcon,
  VideoPlayIcon,
} from "../../constant/imagePath";
import { Row, Col } from "react-bootstrap";
import { Button } from "../Button/Button";
import ReactPlayer from "react-player/lazy";
import Carousel from "react-elastic-carousel";

export const BookALessonCardWithGalleryMobile = ({
  data,
  galleryData,
  disabledBtns,
  onClickbtn1,
  onClickbtn2,
  onClickbtn3,
}) => {
  const [playing, setPlaying] = useState(false);
  console.log("play", playing);
  return (
    <div>
      <style jsx>{`
        .rec-dot {
          background-color: ${Colors.neutralShadesOfPinkSwan};
          border-color: transparent;
          width: 10px;
          heigh: 10px;
          border-radius: 8px;
          box-shadow: unset;
        }
        .rec-dot:hover {
          box-shadow: unset;
        }
        .rec-dot_active {
          background-color: ${Colors.white};
          border-color: transparent;
          box-shadow: unset;
        }
        .rec-carousel-wrapper {
          position: relative;
        }
        .rec-pagination {
          position: absolute;
          bottom: 10%;
        }
        .rec-slider-container {
          margin: 0px;
        }
      `}</style>
      <Row className="g-0">
        {/* Gallery */}
        <Col sm={12} className={classes.carousel}>
          <Carousel itemsToScroll={1} itemsToShow={1} showArrows={false}>
            {galleryData?.map((item) => {
              return item?.videoURL ? (
                <div className={classes.playerWrapper}>
                  <ReactPlayer
                    className={classes.player}
                    url={item?.videoURL}
                    playing={playing}
                    width="100%"
                    height="100%"
                    playIcon={messageIcon}
                    playsinline
                    controls={playing}
                    onReady={true}
                    onStart={() => setPlaying(true)}
                    onPlay={() => setPlaying(true)}
                    onPause={() => setPlaying(false)}
                  />
                  {playing === false && (
                    <div className={classes.overlay}>
                      <div
                        className={classes.overlayIcon}
                        onClick={() => setPlaying(true)}
                      >
                        <img src={VideoPlayIcon} />
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className={classes.slidingImg}>
                  <img src={item?.imageURL} />
                </div>
              );
            })}
          </Carousel>
        </Col>

        {/* Card */}
        <Col sm={12}>
          <div className={classes.purchasedLessonCard}>
            <div className="d-flex">
              <div className={`${[classes.profile].join(" ")}`}>
                <img src={data?.userData?.photo} />
              </div>
              <div>
                <h5 className={classes.mainHeading}>
                  <span
                    style={{ color: Colors.neutralShadesOfNero, ...Fonts.h5 }}
                  >
                    {data?.userData?.displayName.split(" ")[0]}
                  </span>
                  <span
                    style={{ color: Colors.neutralShadesOfNero, ...Fonts.h5 }}
                  >
                    {data?.userData?.displayName.split(" ")[1]}
                  </span>
                </h5>
              </div>
            </div>

            {/* Details */}
            <div
              className={` ${[classes.userDetails].join(" ")}`}
              style={{ borderBottomColor: Colors.neutralShadesOfGainsboro }}
            >
              <span className={classes.starRating}>
                <StarRatings
                  starRatedColor={Colors.mainShadeOfRed}
                  starEmptyColor={Colors.neutralShadesOfDimGray}
                  rating={data?.userData.rating / 5}
                  starDimension={"20px"}
                  numberOfStars={1}
                />
              </span>
              <span
                className={`${[classes.rating].join(" ")}`}
                style={{ color: Colors.neutralShadesOfNero, ...Fonts.h7 }}
              >
                {data?.userData.rating?.toFixed(1)}
              </span>
              <a
                className={`${[classes.reviews].join(" ")}`}
                style={{
                  color: Colors.neutralShadesOfDimGray,
                  ...Fonts.p2,
                }}
              >
                ({data?.userData?.reviews?.length} reviews)
              </a>
              {/* <span
                className={`${[classes.break].join(" ")}`}
                style={{ backgroundColor: Colors.neutralShadesOfDimGray }}
              /> */}
              <span style={{ color: Colors.neutralShadesOfNero, ...Fonts.h9 }}>
                {data?.userData?.sport}
              </span>
              <span
                className={`${[classes.break].join(" ")}`}
                style={{ backgroundColor: Colors.neutralShadesOfDimGray }}
              />

              <span style={{ color: Colors.neutralShadesOfNero, ...Fonts.h9 }}>
                {data?.userData?.city}
              </span>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

BookALessonCardWithGalleryMobile.propTypes = {
  data: PropTypes.object,
  galleryData: PropTypes.array,
};
BookALessonCardWithGalleryMobile.defaultProps = {
  data: {
    userData: {
      displayName: "Micheal Baumgardner",
      photo: coachDemoImg,
      rating: 5,
      sport: "Tennis coach",
      reviews: [{}, {}, {}, {}, {}, {}, {}],
      role: "coach",
      city: "New York",
    },
  },
  galleryData: [
    { videoURL: DummyVideo },
    { imageURL: GalleryImg1 },
    { imageURL: GalleryImg1 },
    { imageURL: GalleryImg1 },
    ,
  ],
};
